import {listener} from "../../../../../modules/vegas/js/util";
import Catalog from "./catalog";

listener('change', '.catalog-controls #in-stock', function (el, e) {
	let input = document.getElementById('catalog-filter-form')?.querySelector('[name="stock"]');
	input.value = Number(el.checked);
	new Catalog().load();
});
